import React from 'react';
import { Checkbox } from 'react-bootstrap';
import { datetimeFormatter } from 'misc/cellFormatters';
import PureRenderComponent from 'components/core/PureRenderComponent';
import ListTable from 'components/core/ListTable';

const CheckboxCellRenderer = (props) => {
  const { data, colDef } = props;
  const { handleSelect, selected } = colDef.cellRendererParams;
  return data && data.id
    ? (
      <Checkbox
        checked={selected.indexOf(data.id) !== -1}
        value={data.id}
        onChange={handleSelect}
        className="mt-5 mb-5" />
    ) : null
}

class NGWordTable extends PureRenderComponent {
  getColumnDefs = () => {
    const  {
      handleTabOpen,
      selected,
      handleSelect
    } = this.props;
      
    const columnDefs = []
  
    columnDefs.push({
      headerName: '',
      field: '',
      suppressFilter: true,
      pinned: 'left',
      width: 30,
      cellRendererFramework: CheckboxCellRenderer,
      cellRendererParams: {
        selected: selected,
        handleSelect: handleSelect
      },
    })
    columnDefs.push({
      headerName: 'Word',
      field: 'word',
      width: 250,
    });
    columnDefs.push({
      headerName: 'Language',
      field: 'language',
      width: 250,
    });
    columnDefs.push({
      headerName: 'Client',
      field: 'client.name',
      width: 250,
    });
    columnDefs.push({
      headerName: 'Created',
      field: 'created',
      valueFormatter: datetimeFormatter,
      width: 150,
    });
    columnDefs.push({
      headerName: 'Modified',
      field: 'modified',
      valueFormatter: datetimeFormatter,
      width: 150,
    });
    return columnDefs;
  }

  render() {
    return (
         <ListTable
            wrapperHeight="83vh"
            columnDefs={this.getColumnDefs()}
            rowData={this.props.ngWords}
            getRowClass={this.getRowClass}
            deltaRowDataMode={true}
            getRowNodeId={data => data.id} />
    );
  }
}

export default NGWordTable;
